// Page: sidebar-video  (shared by sidebar/youtube + sidebar/youtube-inline)
//
// Consolidates two near-identical inline scripts:
//   Enrollment_modules/sidebar/youtube.module/module.html
//   Enrollment_modules/sidebar/youtube-inline.module/module.html
//
// Both had the same visible behaviour: clicking the thumbnail hides it, reveals
// the video, and appends autoplay=1 to the iframe src. The original wired this
// via a global `openPopup()` referenced from an inline `onclick` attribute.
// youtube.module additionally branched on window.location.pathname to bind the
// same handler onto specific per-page widget wrappers (`#page_3_..._widget`,
// `#page_1_my_info_widget`, …) — but every branch did the identical thing:
// bind a thumb to play its own sibling video.
//
// DELIBERATE CHANGE (behaviour-preserving): each module now self-binds its own
// `.youtubevideo-thumb` scoped to `root`, dropping the fragile global `openPopup`
// and the pathname branching. Clicking a thumb plays that module's own video —
// exactly what every original branch resolved to.

export function init(root: HTMLElement): void {
__ea_trace("modules/shared/sidebar-video.ts","init",[root],["root"]);
  const thumb = root.querySelector<HTMLElement>(".youtubevideo-thumb")
  const video = root.querySelector<HTMLElement>(".youtubevideo-video")
  if (!thumb || !video) return

  thumb.addEventListener("click", () => {
__ea_trace("modules/shared/sidebar-video.ts","(anon)",[],[]);
    video.style.display = "block"
    thumb.style.display = "none"
    const iframe = video.querySelector<HTMLIFrameElement>("iframe")
    if (!iframe) return
    const videoSrc = iframe.src
    if (!videoSrc.includes("autoplay=1")) {
      iframe.src = `${videoSrc + (videoSrc.includes("?") ? "&" : "?")}autoplay=1`
    }
  })
}
